import styled from 'styled-components';

export const RecipePanel = styled.article`
  width: 100%;
  
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    grid-column: 2;
    grid-row: 1 / 5;
    align-self: stretch;
    padding: 0 25px;
    padding-top: 45px;
    padding-bottom: 30px;
    
    border-radius: 6px;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
  
  @media (min-width: 1024px) {
    grid-row: 1 / 5;
    grid-column: 3;
    align-self: flex-start;
  }
`;

export const RecipeItem = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 5px 0;
  
  .title {
    font-weight: 600;
    font-size: 25px;
  }
  
  .subtitle {
    display: block;
    margin-top: 10px;
    
    font-weight: 400;
    font-size: 14px;
  }
  
  .price {
    font-weight: 600;
    
    &.small {
      font-size: 20px;
    }
    
    &.large {
      font-size: 24px;
    }
    
    &.normal {
      font-weight: 400;
    }
    
    &.bold {
      font-weight: 700;
    }
    
    &.blue {
      color: ${({ theme }) => theme.blue};
    }
  }
  
  .field {
    margin-right: 20px;
    
    font-weight: 600;
    font-size: 16px;
    
    &.normal {
      font-weight: 400;
    }
    
    &.bold {
      font-weight: 700;
    }
    
    &.green {
      color: ${({ theme }) => theme.green};
    }
    
    &.column span {
      display: block;
    }
  }
  
  .value {
    font-size: 16px;
  
    word-break: break-word;
  }
`;

export const RecipeDelimiter = styled.hr`
  margin: 15px 0;
  padding: 0;
  
  border: none;
  border-bottom: 1px solid #f2f2f2;
`;

export const RecipeButtonContainer = styled.div`
  position: fixed;
  z-index: 2;
  bottom: 0;
  left: 0;
  
  width: 100%;
  padding: 30px 40px;
  
  background-color: ${({ theme }) => theme.white};
  
  button {
    width: 100%;
  }
  
  @media (min-width: 768px) {
    position: static;
    
    margin-top: auto;
    padding: 0 15px;
    padding-top: 30px;
    
    background-color: transparent;
  }
`;
